
(function metadataControllerDefinition() {
    'use strict';
    angular.module('Metadata')
        .controller('MetadataAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminMetadataService', 'authExtend', 'configViewService',
            function metadataController($scope, config, $state, $translate, errors, $stateParams, adminMetadataService, authExtend, configViewService) {
                $scope.aux = {
                    selected: {}
                };

                $scope.metadata = {
                    name: '',
                    systemName: '',
                    label: '',
                    typeDataId: '',
                    organizationalUnitId: authExtend.getOrganizationId(),
                    organizationalUnitName: authExtend.getOrganizationName(),
                    attributes: [],
                    hasAssociatedDocument: false
                };
                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                $scope.aux = {
                    typeData: ''
                }

                $scope.title = 'MetadataAdd';

                adminMetadataService.getTypeDatas().then(function (result) {
                    $scope.typeDatas = result;
                }, function (error) {
                    errors.showError(error);
                    $state.go('metadata-find');
                });

                $scope.createJson = function (attribute) {
                    attribute.value = '';

                    if (attribute.values && attribute.values.length > 0) {
                        var jsonArr = [];
                        for (var i = 0; attribute.values.length > i; i++) {
                            jsonArr.push({
                                value: attribute.values[i].value
                            });
                        }
                        attribute.value = JSON.stringify(jsonArr);
                    }
                }

                $scope.validateAtribute = function () {
                    if ($scope.metadata.attributes.length > 0) {
                        for (var i = 0; $scope.metadata.attributes.length > i; i++) {
                            if ($scope.metadata.attributes[i].type === 'optionsValues') {
                                if ($scope.metadata.attributes[i].values.length <= 0) {
                                    return false;
                                }
                                $scope.createJson($scope.metadata.attributes[i]);
                            }
                        }
                    }
                    return true;
                }

                $scope.save = function () {

                    if (!$scope.metadataForm.$valid || !$scope.validateAtribute()) {
                        $scope.metadataForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    return adminMetadataService.create($scope.metadata).then(function (metadata) {
                        configViewService.clear();
                        if (metadata) {
                            $state.go('metadata-find', { systemName: metadata.systemName });
                        }
                        else {
                            $state.go('metadata-find-menu');
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.selectType = function () {
                    $scope.metadata.attributes = [];

                    if ($scope.aux.typeData) {
                        $scope.metadata.typeDataId = $scope.aux.typeData.id;

                        $scope.aux.typeData.typeDataAttributes.forEach(function (attribute) {
                            $scope.metadata.attributes.push(
                                {
                                    typeDataAttributeId: attribute.id,
                                    typeDataAttributeName: attribute.name,
                                    value: '',
                                    type: attribute.type,
                                    values: []
                                });
                        });

                    } else {
                        $scope.metadata.typeDataId = '';
                    }
                }

                $scope.cancel = function () {
                    $state.go('metadata-find');
                };

                $scope.existValue = function (attribute, value) {
                    if (attribute.values && attribute.values.length > 0) {
                        for (var i = 0; attribute.values.length > i; i++) {
                            if (attribute.values[i].value === value) {
                                return true;
                            }
                        }
                    }

                    return false;
                }

                $scope.addOption = function ($event, attribute) {
                    // para que no ejecute el post al apretar enter
                    $event.stopPropagation();

                    $scope.aux.selected = {};
                    if (attribute.option && attribute.option !== '' && !$scope.existValue(attribute, attribute.option)) {
                        attribute.values.push({ value: attribute.option, isNew: true });
                        attribute.option = '';
                    }
                }

                $scope.removeValue = function (attribute, item) {
                    if (!attribute || !attribute.values) {
                        return;
                    }

                    var indexOf = -1;
                    for (var i = 0; i < attribute.values.length; i++) {
                        if (attribute.values[i] === item) {
                            indexOf = i;
                            break;
                        }
                    }

                    if (indexOf >= 0) {
                        attribute.values.splice(indexOf, 1);
                    }
                }
            }
        ]);
})();